export function getRowValid(row_fix, tour) {
    return {
        "provider": row_fix.row.provider,
        "request_id": row_fix.row.request_id,
        "source_id": row_fix.row.source_id,
        "hash": row_fix.row.hash,
        "currency_class": row_fix.row.currency_class,
        "base_tour": 0,
        "depart_id": row_fix.row.depart_id,
        "depart_name": row_fix.row.depart_name,
        "hotel_id": row_fix.row.hotel_id,
        "hotel_name": row_fix.row.hotel_name,
        "star_id": row_fix.row.star_id,
        "hotelrating": row_fix.row.hotelrating,
        "hoteldescription": row_fix.row.hoteldescription,
        "hotel_image_src": row_fix.row.hotel_image_src,
        "hotel_link": row_fix.row.hotel_link,
        "reviewlink": row_fix.row.reviewlink,
        "country_id": row_fix.row.country_id,
        "country_name": row_fix.row.country_name,
        "town_id": row_fix.row.town_id,
        "town_name": row_fix.row.town_name,
        "subregion_id": row_fix.row.subregion_id,
        "subregionname": row_fix.row.subregionname,
        "isphoto": row_fix.row.isphoto,
        "isdescription": row_fix.row.isdescription,
        "isreviews": row_fix.row.isreviews,
        "iscoords": row_fix.row.iscoords,
        "seadistance": row_fix.row.seadistance,
        "currency": row_fix.row.currency,
        "priceue": tour.priceue,
        "offer_id": tour.tourid,
        "place_id": tour.placement,
        "place_name": tour.placement,
        "room_id": tour.room,
        "room_name": tour.room,
        "oper_id": tour.operatorcode,
        "oper_name": tour.operatorname,
        "child": row_fix.row.child,
        "ages": row_fix.row.ages,
        "meal_full": tour.mealrussian,
        "meal_id": tour.mealcode,
        "meal_name": tour.meal,
        "star_name": row_fix.row.starname,
        "dt1": tour.flydate,
        "nights": tour.nights,
        "dt2": tour.flydate,
        "volatility": row_fix.row.volatility,
        "text": row_fix.row.text,
        "discount": false,
        "comment": "",
        "full_price": tour.price,
        "price": tour.price,
        "claim_mark": "tourist",
        "credit": false,
        "promo": 0,
        "hotel_adult": tour.adults,
        "hotel_child": tour.child,
        "adult": row_fix.row.adult
    };
}